import * as constActions from './const';
import api from '../api/api';
import { eUserPermissions } from '../Enums/Enums';
import { LOGIN_ROUTES, TOKENS } from 'pages/auth/constants';
import { eRoleType } from 'store/slices/userSlice/';
import { reportEvent } from 'utils/analytics';
import { isRenderedAsIframeInNewUI } from 'config';

export function getAllUsers() {
  return function (dispatch) {
    return api
      .getAllUsers()
      .then(users => {
        dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function getAllUsersGlobal(clientId) {
  return function (dispatch) {
    return api
      .getAllGlobalUsers(clientId)
      .then(users => {
        dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function addUser(user) {
  return function (dispatch, getState) {
    let state = getState().userManagement;
    return api
      .addUser(user)
      .then(result => {
        if (result.Success) {
          let userAdded = JSON.parse(result.PayLoad);
          let newUserObject = Object.assign({}, user, { userId: userAdded.userId, userRoleId: userAdded.userRoleId });
          let users = Object.assign([], state.users, [...state.users, newUserObject]);
          dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        }

        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}
export function addUserGlobal(user, clientId) {
  return function (dispatch, getState) {
    let state = getState().userManagement;
    return api
      .addUserGlobal(user, clientId)
      .then(result => {
        if (result.Success) {
          let userAdded = JSON.parse(result.PayLoad);
          let newUserObject = Object.assign({}, user, { userId: userAdded.userId, userRoleId: userAdded.userRoleId });
          let users = Object.assign([], state.users, [...state.users, newUserObject]);
          dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        }

        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function deleteUser(userId) {
  return function (dispatch, getState) {
    let state = getState().userManagement;
    return api
      .deleteUser(userId)
      .then(result => {
        if (result.success != false) {
          let users = Object.assign(
            [],
            state.users.filter(curr => curr.UserId != userId)
          );
          dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        }

        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}
export function deleteUserGlobal(userId, clientId) {
  return function (dispatch, getState) {
    let state = getState().userManagement;
    return api
      .deleteUserGlobal(userId, clientId)
      .then(result => {
        if (result.success != false) {
          let users = Object.assign(
            [],
            state.users.filter(curr => curr.userId != userId)
          );
          dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        }

        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserEmail(changeEmail) {
  return function (dispatch, getState) {
    return api
      .changeUserEmail(changeEmail)
      .then(result => {
        const { UserId, NewEmail } = changeEmail;
        const state = getState().userManagement;
        const users = state.users.map(user => (user.userId === UserId ? { ...user, email: NewEmail } : user));
        dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        return result;
      })
      .catch(error => {
        throw error;
      });
  };
}

export function changeUserPassword(changePassword) {
  return function (dispatch, getState) {
    return api
      .changeUserPassword(changePassword)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}
export function changeUserPasswordGlobal(changePassword, clientId) {
  return function (dispatch, getState) {
    return api
      .ChangeUserPasswordGlobal(changePassword, clientId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserEmailGlobal(changeEmail, clientId) {
  return function (dispatch, getState) {
    return api
      .ChangeUserEmailGlobal(changeEmail, clientId)
      .then(result => {
        const { UserId, NewEmail } = changeEmail;
        const state = getState().userManagement;
        const users = state.users.map(user => (user.userId === UserId ? { ...user, email: NewEmail } : user));
        dispatch({ type: constActions.UPDATE_USERS_SUCCESS, users });
        return result;
      })
      .catch(error => {
        throw error;
      });
  };
}

export function getUserPermissions(userId) {
  return function (dispatch, getState) {
    return api
      .getUserPermissions(userId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}
export function getUserPermissionsGlobal(userId, clientId) {
  return function (dispatch, getState) {
    return api
      .getUserPermissionsGlobal(userId, clientId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function getMfaStatusByUserId(userId) {
  return function (dispatch, getState) {
    return api
      .getMfaStatusByUserId(userId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function getMfaStatusByUserIdGlobal(userId, clientId) {
  return function (dispatch, getState) {
    return api
      .getMfaStatusByUserIdGlobal(userId, clientId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

//is mfa enabled
export function checkIsMfaEnabled() {
  return function (dispatch) {
    return api
      .isMfaEnabled()
      .then(isMfaEnabled => {
        dispatch({ type: constActions.GET_IS_MFA_ENABLED_SUCCESS, isMfaEnabled });
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

//is mfa enabled Global
export function checkIsMfaEnabledGlobal(clientId) {
  return function (dispatch) {
    return api
      .isMfaEnabledGlobal(clientId)
      .then(isMfaEnabled => {
        dispatch({ type: constActions.GET_IS_MFA_ENABLED_SUCCESS, isMfaEnabled });
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function DispatchCheckIsAddUsernameInEmailFormat(isAddUsernameInEmailFormat) {
  return { type: constActions.GET_IS_ADD_USERNAME_IN_EMAIL_FORMAT_SUCCESS, isAddUsernameInEmailFormat };
}

//check when Adding a User the username will be in email format only
export function checkIsAddUsernameInEmailFormat() {
  return function (dispatch) {
    return api
      .isAddUsernameInEmailFormat()
      .then(isAddUsernameInEmailFormat => {
        dispatch(DispatchCheckIsAddUsernameInEmailFormat(isAddUsernameInEmailFormat));
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

//check when Adding a User the username will be in email format only in global
export function checkIsAddUsernameInEmailFormatGlobal(clientId) {
  return function (dispatch) {
    return api
      .isAddUsernameInEmailFormatGlobal(clientId)
      .then(isAddUsernameInEmailFormat => {
        dispatch(DispatchCheckIsAddUsernameInEmailFormat(isAddUsernameInEmailFormat));
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function changeUserPermissionGlobal(userId, permission, clientId) {
  return function (dispatch, getState) {
    return api
      .changeUserPermissionGlobal(userId, permission, clientId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserPermission(userId, newUserPermisions) {
  return function (dispatch, getState) {
    return api
      .changeUserPermission(userId, newUserPermisions)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserMfaSettings(userId, userMfaAction, userPhoneNumber) {
  return function (dispatch, getState) {
    return api
      .changeUserMfaSettings(userId, userMfaAction, userPhoneNumber)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserMfaSettingsGlobal(userId, userMfaAction, userPhoneNumber, clientId) {
  return function (dispatch, getState) {
    return api
      .changeUserMfaSettingsGlobal(userId, userMfaAction, userPhoneNumber, clientId)
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function hasPermission(permission) {
  return function (dispatch, getState) {
    let state = getState().user;
    let permissions = state.loggedUser.permissions;

    if (Object.keys(state.loggedUser).length === 0 || state.loggedUser.userRoleType == null) {
      return false;
    } else {
      let UserRoleType = state.loggedUser.userRoleType;
      let x = state.loggedUser.userRoleType;
      if (UserRoleType == eRoleType.OPERATOR || UserRoleType == eRoleType.GLOBAL_OPERATOR) {
        return true;
      } else if (UserRoleType == eRoleType.DASHBOARD) {
        return permission.value == eUserPermissions.DASHBOARD;
      } else if (UserRoleType == eRoleType.CUSTOM_USER) {
        return permissions.filter(cur => cur == permission.value).length > 0;
      } else {
        return false;
      }
    }
  };
}

export function didUserPermissionsLoad() {
  return function (dispatch, getState) {
    let loggedUser = getState().user.loggedUser;
    let retVal;
    if (
      Object.keys(loggedUser).length === 0 ||
      loggedUser.userRoleType == null ||
      loggedUser.userRoleType == eRoleType.UNKNOWN
    ) {
      retVal = false;
    } else {
      retVal = true;
    }

    return retVal;
  };
}

export function validateUserActivity(permission) {
  return function (dispatch, getState) {
    return api
      .validateUserActivity()
      .then(result => {
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function getUserRoles() {
  return function (dispatch) {
    return api
      .getUserRoles()
      .then(result => {
        if (result.Success) {
          let roles = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.GET_USER_ROLES_SUCESS, roles });
        }
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function getUserRolesGlobal(clientId) {
  return function (dispatch) {
    return api
      .getUserRolesGlobal(clientId)
      .then(result => {
        if (result.Success) {
          let roles = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.GET_USER_ROLES_SUCESS, roles });
        }
      })
      .catch(error => {
        console.warn(error);
      });
  };
}

export function addUserRole(addUserRoleDTO) {
  return function (dispatch) {
    return api
      .addUserRole(addUserRoleDTO)
      .then(result => {
        if (result.Success) {
          const role = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.ADD_ROLE_SUCESS, role });
        }

        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function addUserRoleGlobal(addUserRoleDTO, clientId) {
  return function (dispatch) {
    return api
      .addUserRoleGlobal(addUserRoleDTO, clientId)
      .then(result => {
        if (result.Success) {
          let role = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.ADD_ROLE_SUCESS, role });
        }

        return result;
      })
      .catch(error => {
        throw error;
      });
  };
}

export function changeUserRole(userId, userRoleId) {
  return function (dispatch) {
    return api
      .changeUserRole(userId, userRoleId)
      .then(result => {
        if (result.Success) {
          let user = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.UPDATE_USER_ROLE_SUCESS, user });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeUserRoleGlobal(userId, userRoleId, clientId) {
  return function (dispatch) {
    return api
      .changeUserRoleGlobal(userId, userRoleId, clientId)
      .then(result => {
        if (result.Success) {
          let user = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.UPDATE_USER_ROLE_SUCESS, user });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeRolePermissions(roleId, newRolePermissions) {
  return function (dispatch) {
    return api
      .changeRolePermissions(roleId, newRolePermissions)
      .then(result => {
        if (result.Success) {
          let role = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.UPDATE_ROLE_PERMISSIONS_SUCESS, role });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeRolePermissionsGlobal(roleId, newRolePermissions, clientId) {
  return function (dispatch) {
    return api
      .changeRolePermissionsGlobal(roleId, newRolePermissions, clientId)
      .then(result => {
        if (result.Success) {
          let role = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.UPDATE_ROLE_PERMISSIONS_SUCESS, role });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function deleteRole(roleId) {
  return function (dispatch) {
    return api
      .deleteRole(roleId)
      .then(result => {
        if (result.Success) {
          dispatch({ type: constActions.REMOVE_ROLE_SUCESS, roleId });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function deleteRoleGlobal(roleId, clientId) {
  return function (dispatch) {
    return api
      .deleteRoleGlobal(roleId, clientId)
      .then(result => {
        if (result.Success) {
          dispatch({ type: constActions.REMOVE_ROLE_SUCESS, roleId });
        }
        return result;
      })
      .catch(error => {
        console.warn(error);
        throw error;
      });
  };
}

export function changeRoleSitesGlobal(roleId, sites, clientId) {
  return function (dispatch) {
    return api
      .changeRoleSitesGlobal(roleId, sites, clientId)
      .then(result => {
        if (result.Success) {
          const role = JSON.parse(result.PayLoad);
          dispatch({ type: constActions.UPDATE_ROLE_SITES_SUCESS, role });
        }
        return result;
      })
      .catch(error => {
        throw error;
      });
  };
}

export function logOut(reasonCode) {
  if (isRenderedAsIframeInNewUI) {
    return;
  }
  reportEvent('user_logout');
  localStorage.removeItem(TOKENS.AUTH_TOKEN_SESSION_KEY);
  localStorage.removeItem(TOKENS.ACCESS_TOKEN_EXPIRATION);
  localStorage.removeItem(TOKENS.IS_SITE_CONTAINER_ROUTE);
  api.logout(reasonCode).finally(() => (window.location.href = LOGIN_ROUTES.LOGIN));
}
